import { useEffect, useState } from "react";

export enum DeviceType {
  Mobile = "mobile",
  Tablet = "tablet",
  Desktop = "desktop",
  Widescreen = "widescreen",
}

const TABLET_BREAKPOINT_MIN = 768; // Up to 767px is Mobile
const DESKTOP_BREAKPOINT_MIN = 1024; // 768px to 1023px is Tablet
const WIDESCREEN_BREAKPOINT_MIN = 1440; // 1024px to 1439px is Desktop, 1440px+ is Widescreen

export function getDeviceType(width: number): DeviceType {
  if (width < TABLET_BREAKPOINT_MIN) {
    return DeviceType.Mobile;
  }
  if (width < DESKTOP_BREAKPOINT_MIN) {
    return DeviceType.Tablet;
  }
  if (width < WIDESCREEN_BREAKPOINT_MIN) {
    return DeviceType.Desktop;
  }
  return DeviceType.Widescreen;
}

export function useDevice() {
  const [deviceType, setDeviceType] = useState<DeviceType | undefined>(() => {
    if (typeof window !== "undefined") {
      return getDeviceType(window.innerWidth);
    }
    return undefined;
  });

  useEffect(() => {
    const handleResize = () => {
      setDeviceType(getDeviceType(window.innerWidth));
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return {
    deviceType,
    isMobile: deviceType === DeviceType.Mobile,
    isTablet: deviceType === DeviceType.Tablet,
    isDesktop: deviceType === DeviceType.Desktop,
    isWidescreen: deviceType === DeviceType.Widescreen,
    isMobileOrTablet: deviceType === DeviceType.Mobile || deviceType === DeviceType.Tablet,
    isDesktopOrWidescreen: deviceType === DeviceType.Desktop || deviceType === DeviceType.Widescreen,
  };
}
